/*@ngInject*/
const UpdateCollaborationEmailRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.updateCollaborationEmail = function (email) {
        let url = '/rest/Email/' + email.id;

        return this.post(url, email);
    };
};

angular.module('gw-um-submission')
    .service('updateCollaborationEmailRepository', UpdateCollaborationEmailRepository);
